export default "__VITE_ASSET__Ctny0UuM__"